import { registerPlugin } from '@capacitor/core';
export const NoCodesPlugin = registerPlugin('NoCodes');
//# sourceMappingURL=NoCodesNativePlugin.js.map